import React from 'react';
import { BlockProps } from './blocksTypes';
import { useNewUiTheme } from '../newUiTheme';

export function ItemsListLayout(props: BlockProps) {
  const uiTheme = useNewUiTheme();

  return (
    <uiTheme.common.ItemsListLayout
      style={props.style}
      className={props.className}
      testID={props.testID}
      onClick={props.onClick}
    >
      {props.children}
    </uiTheme.common.ItemsListLayout>
  );
}
